import T from "react";
import e from "prop-types";
import c from "classnames";
import t from "./index44.mjs";
import { LINK_REFFERRER_POLICIES as m, LINK_RELATIONSHIPS as I, LINK_TARGETS as E, LINK_TYPES as O, LINK_BASE_CLASS as s } from "./index45.mjs";
import { TYPOGRAPHY_TEXT_ALIGN as L, TYPOGRAPHY_TEXT_TRANSFORM as R, TYPOGRAPHY_WEIGHTS as S, TYPOGRAPHY_SIZES as d } from "./index46.mjs";
const p = ({
  classes: a,
  type: o,
  color: n,
  size: i,
  textAlign: l,
  textTransform: r,
  weight: _
}) => c(
  t[s],
  t[`${s}--${o}`],
  t[`${s}--${n}`],
  t[`${s}--${i}`],
  t[`${s}--${l}`],
  t[`${s}--${r}`],
  t[`${s}--${_}`],
  a
), f = (a) => {
  const { children: o, mediaType: n, style: i } = a, l = p(a), r = { ...a, type: n };
  return delete r.mediaType, delete r.text, /* @__PURE__ */ T.createElement("div", { className: l, style: i }, /* @__PURE__ */ T.createElement("a", { ...r }, o));
};
f.propTypes = {
  children: e.node.isRequired,
  download: e.bool,
  hrefLang: e.string,
  media: e.string,
  ping: e.string,
  referrerPolicy: e.oneOf(Object.values(m)),
  rel: e.oneOf(Object.values(I)),
  target: e.oneOf(Object.values(E)),
  href: e.string.isRequired,
  mediaType: e.string,
  type: e.oneOf(Object.values(O)),
  textAlign: e.oneOf(Object.values(L)),
  textTransform: e.oneOf(Object.values(R)),
  weight: e.oneOf(Object.values(S)),
  classes: e.string,
  size: e.oneOf(Object.values(d)),
  style: e.object,
  color: e.string
};
f.defaultProps = {
  download: !1,
  target: E.BLANK,
  type: O.DEFAULT
};
export {
  s as LINK_BASE_CLASS,
  m as LINK_REFFERRER_POLICIES,
  I as LINK_RELATIONSHIPS,
  E as LINK_TARGETS,
  O as LINK_TYPES,
  f as Link,
  f as default
};
